import * as React from 'react';
import { Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission } from 'core/api';
import { ThemeManager } from 'pos/ui';

import Phone from './ShowInvoicesScreen.Phone';
import Tablet from './ShowInvoicesScreen.Tablet';
import WebPos from './ShowInvoicesScreen.WebPos';
import { Props as CommonProps } from './ShowInvoicesScreen.Common';

import { CashdrawerFacade, InvoiceFacade } from 'pos/facades';
import { SaleModuleNextAction } from 'pos/modules/helpers/SaleModuleNextAction';
import { Modal } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		showInvoices: () => Promise<Result<SaleModuleNextAction>>
	}
}

function ShowInvoicesScreen(props: CommonProps) {
	if (ThemeManager.isPhone())
		return <Phone {...props} />;

	if (ThemeManager.isTablet())
		return <Tablet {...props} />;

	if (ThemeManager.isWebPos())
		return <WebPos {...props} />;

	return null;
}

Command.register('showInvoices', Preconditions.ensure(Permission.Ticket_ViewClosed), async (): Promise<Result<SaleModuleNextAction>> => {
	const businessDay = await CashdrawerFacade.getCurrentBusinessDay();
	if (!businessDay)
		return Result.error();

	const allSeries = await InvoiceFacade.getSeries();

	return Modal.show(ShowInvoicesScreen, { businessDay, initialAllSeries: allSeries });
});
